export default __webpack_public_path__ + "static/media/circle.96382923.svg";